import { Serializable } from "./Serializable";
import { Subject } from "./subject";
import { User } from "./user";

export enum PostTypeEnums {
    LINK = "LINK",
    DOCUMENT = "DOCUMENT",
    DISCUSSION = "DISCUSSION"
}

export enum EventTypeEnums {
    VIEW_IN_BROWSER = 4
}

export class Document implements Serializable<Document> {
    id: string;
    originId: string;
    subject: Subject;
    filename: string;
    title: string;
    viewonly: boolean;
    type: string;
    owner: User;
    resource: string;
    content: any;
    activityDate: any;
    ownerId: number;
    subjectId: number;
    documentType: string;
    providerType;
    providerName: string;
    comment: string;
    displayData: string; // Truncated of status
    keywords: string;
    attachmentContents: string;
    attachments: Document[] = [];
    formUri: string;
    filetype: string;
    firstComment: string;
    isDeleted;
    permissions: any;
    thumbnail: string;
    contentType;
    documentUsers: User[] = [];
    commentsCount: number;
    subjectFullName: string;
    ownerFullName: string;
    subjectAge: any;
    attachmentId;
    lastUpdatedTime: string;
    lastActionTime: string;
    createdDate: any;
    documentViewers: any;
    code: string;
    userId: number;
    uploading: boolean;
    failed: boolean;
    isConvertedPdf: boolean;
    permissionType: string;
    sharedFailedUsersIds: string;
    documentFolderId: number;
    postType: string;
    hasNotificationUpdate: boolean;
    isSelected: boolean;
    documentViewerIds: Array<number>;
    permissionEndDate: string;
    viewed: boolean;
    assignedFormId: number;
    userPerm: any;
    url: string;
    linkType: string;
    parentFolderName: string;
    careItemId: number;
    summaryGenerated: boolean;
    photoFile: any;

    public _subjectFullName() {
        if (!!this.subject)
            this.subjectFullName = this.subject.fullName;
        else
            this.subjectFullName = '< Subject Id ' + this.subjectId + '>';
    }

    public _ownerFullName() {
        if (!!this.owner)
            this.ownerFullName = this.owner.fullName;
        else
            this.ownerFullName = '< Owner Id ' + this.ownerId + '>';
    }



    deserialize(input) {
        this.isDeleted = false;
        input.providerType && (this.providerType = input.providerType);
        input.providerName && (this.providerName = input.providerName);
        input.formUri && (this.formUri = input.formUri);
        input.keywords && (this.keywords = input.keywords);
        input.subjectId && (this.subjectId = input.subjectId);
        input.filetype && (this.filetype = input.filetype);

        this.permissions = [];

        input.id && (this.id = input.id);
        input._id && (this.id = input._id);
        input.documentType && (this.documentType = input.documentType);
        input.displayData && (this.displayData = input.displayData);
        input.ownerId && (this.ownerId = input.ownerId);
        input.owner && (this.ownerId = input.owner.id);
        input.originId && (this.originId = input.originId);

        input.subjectId && (this.subjectId = input.subjectId);
        input.careItemId && (this.careItemId = input.careItemId);
        input.comment && (this.comment = input.comment);
        !!input.commentsCount && (this.commentsCount = input.commentsCount) || (this.commentsCount = 0);
        input.subject && (this.subject = new Subject().deserialize(input.subject));

        input.filename && (this.filename = input.filename);
        input.title && (this.title = input.title);
        input.url && (this.url = input.url);
        input.linkType && (this.linkType = input.linkType);
        input.type && (this.type = input.type);
        input.resource && (this.resource = input.resource);
        input.viewonly && (this.viewonly = input.viewonly);
        input.owner && (this.owner = new User().deserialize(input.owner));
        input.content && (this.content = input.content);
        input.activityDate && (this.activityDate = new Date(input.activityDate));
        input.lastUpdatedTime && (this.lastUpdatedTime = input.lastUpdatedTime);
        input.lastActionTime && (this.lastActionTime = input.lastActionTime);
        input.activityDate && (this.createdDate = new Date(input.activityDate));
        input.documentViewers && (this.documentViewers = input.documentViewers);
        input.code && (this.code = input.code);
        input.userId && (this.userId = input.userId);
        (input.uploading != null) && (this.uploading = input.uploading);
        (input.failed != null) && (this.failed = input.failed);
        input.documentViewerIds && (this.documentViewerIds = input.documentViewerIds);
        input.sharedFailedUsersIds && (this.sharedFailedUsersIds = input.sharedFailedUsersIds);
        !!input.documentFolderId && (this.documentFolderId = input.documentFolderId);
        input.postType && (this.postType = input.postType);
        this.permissionEndDate = input.permissionEndDate;
        this.viewed = input.viewed;
        this.assignedFormId = input.assignedFormId;
        this.parentFolderName = input.parentFolderName;
        input.thumbnail && (this.thumbnail = input.thumbnail);
        this.summaryGenerated = input.summaryGenerated;

        for (var i = 0; !!input.permissions && i < input.permissions.length; i++) {
            this.permissions.push(input.permissions[i]);
        }

        if (!!input.documentUsers) {
            for (var i = 0; i < input.documentUsers.length; i++) {
                this.documentUsers.push(new User().deserialize(input.documentUsers[i]));
            }
        }

        for (var i = 0; !!input.attachments && i < input.attachments.length; i++) {
            this.attachments.push(new Document().deserialize(input.attachments[i]));
        }

        this.isConvertedPdf = !!input.isConvertedPdf; //always set it to true or false
        !!input.permissionType && (this.permissionType = input.permissionType);
        input.hasNotificationUpdate && (this.hasNotificationUpdate = input.hasNotificationUpdate);

        this._ownerFullName();
        this._subjectFullName();

        return this;
    }

    constructor() {
    }

    hasImage = (): boolean => {
        return (
            !!this.thumbnail ||
            (!!this.attachments[0] && !!this.attachments[0].thumbnail)
        );
    }

    hasFile = (): boolean => {
        return !this.hasImage() && (!!this.filename && this.filename != '' && this.keywords != 'status');

    }

    hasAttachment = (): boolean => {
        return this.hasFile() || this.hasImage();
    }

    hasComments = (): boolean => {
        return !!this.commentsCount || !!this.firstComment || !!this.comment;
    }

    canShare = (userId?: number): boolean => {
        // Discussions can be shared as they do not have view-only mode
        if (!this.hasAttachment()) {
            return true;
        }
        if (!!userId) {
            let user = (this.documentUsers || []).find((u) => u.id == userId);
            if (!!user) {
                return user.permissionType == 'ACCESS' || user.permissionType == 'OWN';
            }
        }

        if (!!this.permissionType) {
            return this.permissionType == 'ACCESS' || this.permissionType == 'OWN';
        }

        return false;
    }
}
